import fileSize from 'filesize';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
export const linkToFile = async (link, { $t }) => {
    var _a;
    const url = new URL(link);
    try {
        const blob = await fetch(url === null || url === void 0 ? void 0 : url.href, {
            method: 'GET',
        }).then(r => r.blob());
        const fileName = (_a = url === null || url === void 0 ? void 0 : url.href) === null || _a === void 0 ? void 0 : _a.split('/').slice(-1)[0];
        const file = new File([blob], fileName, {
            type: blob.type,
        });
        return file;
    }
    catch (error) {
        toast({
            title: $t({
                id: 'Generics.Error',
                defaultMessage: 'Error',
            }),
            description: error.message,
            status: 'error',
        });
        return undefined;
    }
};
export const fileSizeLimitError = (limit, type, { $t }) => {
    if (!limit) {
        return '';
    }
    const fileSizeStr = fileSize(limit, {
        spacer: '',
    });
    if (type === 'image') {
        return $t({
            id: 'Generics.ImageSizeLimit',
            defaultMessage: 'The image size limit is {size_limit}.',
        }, { file_type: type, size_limit: fileSizeStr });
    }
    return $t({
        id: 'Generics.FileSizeLimit',
        defaultMessage: 'The file size limit is {size_limit}.',
    }, { file_type: type, size_limit: fileSizeStr });
};
//# sourceMappingURL=upload.js.map